var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.currentUser && _vm.currentUser.operations)?[_c('HeaderLayout'),_c('v-main',[_c('router-view')],1),_c('FooterLayout')]:[_c('v-main',[_c('router-view')],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }